<template>
  <div>
    <facit-header></facit-header>
    <div class="profile-div col-12">
      <h5 class="mt-3 mb-3"> User Management </h5>
      <b-row class="float-right">
        <b-col class="my-1">
          <b-form-group horizontal label="" class="mb-3">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search" />
              <b-btn class="clearBtn" :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table striped hover show-empty empty-text="There are no users to show" :fields="userList" :items="users"
        :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
        <template slot="link" slot-scope="data">
          <div style="display: flex;justify-content: space-between;">
            <i @click="getHistory(data.item.id)" title="History Detail">
              <v-icon v-b-tooltip.hover title="User History" style="cursor: pointer;" name="info" base-class="icon-width"
                @click="getHistory(data.item.id)">
              </v-icon>
            </i>
            <i @click="getDetail(data.item.id)" title="User Settings">
              <v-icon v-b-tooltip.hover title="User Settings" style="cursor: pointer;" name="settings"
                base-class="icon-width" @click="getDetail(data.item.id)">
              </v-icon>
            </i>
            <i @click="getProductKey(data.item.id)" title="Device">
              <!-- <v-icon name="info" base-class="icon-width" @click="getProductKey(data.item.id)">
              </v-icon> -->
              <img v-b-tooltip.hover title="Device" class="mb-3" src="../../assets/img/laptop.png"
                style="width: 20px;cursor: pointer;" @click="getProductKey(data.item.id)" />
            </i>

          </div>
        </template>
        <template slot="emailVerified" slot-scope="data">
          <label class="switch">
            <input type="checkbox" v-model="data.value" @change="emailStatusUpdate(data.item.id, data.value)">
            <span class="slider round"></span>
          </label>
        </template>
        <!-- <template slot="payAsGo" slot-scope="data">
          <label class="switch">
            <input type="checkbox" v-model="data.value" @change="statusUpdate(data.item.id, data.value)">
            <span class="slider round"></span>
          </label>
        </template> -->
      </b-table>
      <br>
      <b-pagination align="right" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      <b-modal v-model="userSettingsModal" hide-footer title="User Settings">
        <b-form @submit.prevent="updateProfile('formRegistration')" class="ml-4 mr-4 mb-4"
          data-vv-scope="formRegistration">
          <b-form-group id="nameGroup">
            <b-row class="my-1">
              <b-col sm="4">
                <label for="input-small">Package</label>
              </b-col>
              <b-col sm="8">
                <b-form-select @change="amount11()" v-model="amount" class="mb-3">
                  <option value="null"> Select Package </option>
				  <optgroup label="Facit Packages">
					<option
					   v-for="(list, index) in (this.options || []).filter(o => o &&  o.userId === 'e8e693d9-7b4a-47b1-8102-b0ad05cb701e')"
						:key="`special-${index}`"
					  :value="list.id"
					>
					  {{ list.packageName }} - £{{ list.totalCost }}.00
					</option>
				  </optgroup>
				  <optgroup label="Other Packages">
					<option
					 v-for="(list, index) in (options || []).filter(o => !o || o.userId !== 'e8e693d9-7b4a-47b1-8102-b0ad05cb701e')"
					  :key="`other-${index}`"
					  :value="list.id"
					>
					  {{ list.packageName }} - £{{ list.totalCost }}.00
					</option>
				  </optgroup>
                </b-form-select>
              </b-col>
            </b-row>
          </b-form-group>

          <!-- <b-form-group id="nameGroup">
            <b-row class="my-1">
              <b-col sm="4">
                <label for="input-small">Trail Days</label>
              </b-col>
              <b-col sm="8">
                <b-form-input id="limit" name="limit" type="text" v-if="amount == 1" v-model="trialLimit"
                  v-validate="'required'" :class="{
                    'input': true,
                    'is-danger': errors.has('formRegistration.limit')
                  }" required placeholder="Trail Limit">
                </b-form-input>
                <b-form-input id="limit" name="limit" type="text" v-else disabled v-model="trialLimit"
                  v-validate="'required'" :class="{
                    'input': true,
                    'is-danger': errors.has('formRegistration.limit')
                  }" required placeholder="Trail Limit">
                </b-form-input>
                <i v-show="errors.has('formRegistration.firstname')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.firstname')" class="help is-danger">{{
                  errors.first('formRegistration.firstname')
                }}
                </span>
              </b-col>
            </b-row>
          </b-form-group> -->

          <b-form-group id="nameGroup">
            <b-row class="my-1">
              <b-col sm="4">
                <label for="input-small">Expiry Date</label>
              </b-col>
              <b-col sm="8">
                <input class="form-control" type="date" v-model="datePickerVal" />
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group id="nameGroup">
            <b-row class="my-1">
              <b-col sm="4">
                <label for="input-small">Credits</label>
              </b-col>
              <b-col sm="8">
                <b-form-input id="credit" name="credit" type="text" v-model="credits" v-validate="'required'" :class="{
                  'input': true,
                  'is-danger': errors.has('formRegistration.credit')
                }" required placeholder="Credit">
                </b-form-input>
                <i v-show="errors.has('formRegistration.credit')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.credit')" class="help is-danger">{{
                  errors.first('formRegistration.credit')
                }}
                </span>
              </b-col>
            </b-row>
          </b-form-group>
		  
          <b-form-group id="nameGroup">
            <b-row class="my-1">
              <b-col sm="4">
                <label for="input-small">Purchased Credits</label>
              </b-col>
              <b-col sm="8">
                <b-form-input id="extracredits" name="extracredits" type="text" v-model="extracredits" v-validate="'required'" :class="{
                  'input': true,
                  'is-danger': errors.has('formRegistration.extracredits')
                }" required placeholder="Purchased Credit">
                </b-form-input>
                <i v-show="errors.has('formRegistration.extracredits')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.extracredits')" class="help is-danger">{{
                  errors.first('formRegistration.extracredits')
                }}
                </span>
              </b-col>
            </b-row>
          </b-form-group>
		  
          <b-form-group id="nameGroup">
            <b-row class="my-1">
              <b-col sm="4">
                <label for="input-small">Total Devices</label>
              </b-col>
              <b-col sm="8">
                <b-form-input id="devices" name="devices" type="text" v-model="devices" v-validate="'required'" :class="{
                  'input': true,
                  'is-danger': errors.has('formRegistration.devices')
                }" required placeholder="Total Devices">
                </b-form-input>
                <i v-show="errors.has('formRegistration.devices')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.devices')" class="help is-danger">{{
                  errors.first('formRegistration.devices')
                }}
                </span>
              </b-col>
            </b-row>
          </b-form-group>
          <b-button type="submit" class="w-100" variant="warning">Update</b-button>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import FacitHeader from '@/components/header';
import moment from 'moment';

export default {
  name: 'userManagement',
  components: { FacitHeader },
  data() {
    return {
      datePickerVal: new Date(),
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      users: null,
      history: null,
      userSettingsModal: false,
      trialLimit: null,
      amount: null,
      credits: null,
      extracredits: null,
      options: null,
      userId: null,
      accountType: 0,
      purchased: false,
      filter: null,
      devices: null,
      moment: moment,
      userList: [
        {
          key: 'id',
          label: 'Licence Key',
          sortable: true,
        },
        {
          key: 'firstname',
          label: 'First Name',
          sortable: true,
        },
        {
          key: 'lastname',
          label: 'Last Name',
          sortable: true,
        },
        {
          key: 'email',
          label: 'Email Address',
          sortable: true,
        },
        {
          key: 'companyname',
          label: 'Company Name',
          sortable: true,
        },
        {
          key: 'country',
          label: 'Country',
          sortable: false,
        },
        {
          key: 'emailVerified',
          label: 'Status',
          sortable: true,
        },
        // {
        //   key: 'payAsGo',
        //   label: 'Pay as you go',
        // },
        {
          key: 'created',
          label: 'Created',
          sortable: true,
          formatter: (value) => {
            return moment.utc(value).format('DD-MM-YYYY HH:mm');
          },
        },
        {
          key: 'link',
          label: 'Action',
          sortable: false,
        },
      ],
    };
  },
  async created() {
    this.getUsers();
    this.getPackageList();
  },
  // watch: {
  //   async amount() {
  //     let packageList = await API.get(`PackageLists`);
  //     console.log(this.credits,"packageList", packageList)
  //     packageList = await packageList.filter((res) => {
  //       return res.id == this.amount
  //     })
  //     console.log("-->>", packageList[0]['totalCost'])
  //     const packageId = this.amount;
  //     if (packageId === 1) {
  //       this.credits = 0;
  //       this.trialLimit = 7;
  //       this.accountType = 0;
  //       this.purchased = false;
  //     }
  //     else if (packageId === 2) {
  //       this.credits = 495;
  //       this.trialLimit = this.trialLimit;
  //       this.accountType = 1;
  //       this.purchased = true;
  //     } else if (packageId === 3) {
  //       this.credits = 1995;
  //       this.trialLimit = this.trialLimit;
  //       this.accountType = 1;
  //       this.purchased = true;
  //     } else if (packageId === 4) {
  //       this.credits = 3995;
  //       this.trialLimit = this.trialLimit;
  //       this.accountType = 1;
  //       this.purchased = true;
  //     }
  //     else {
  //       this.credits = packageList[0]['totalCost'];
  //       this.trialLimit = this.trialLimit;
  //       this.accountType = 1;
  //       this.purchased = true;
  //     }
  //   },
  // },
  methods: {
    async amount11() {
      let packageList = await API.get(`PackageLists`);
      packageList = await packageList.filter((res) => {
        return res.id == this.amount
      })
      const packageId = this.amount;
      if (packageId === 1) {
        this.credits = 0;
        this.trialLimit = 7;
        this.accountType = 0;
        this.purchased = false;
      }
      else if (packageId === 2) {
        this.credits = 495;
        this.trialLimit = this.trialLimit;
        this.accountType = 1;
        this.purchased = true;
      } else if (packageId === 3) {
        this.credits = 1995;
        this.trialLimit = this.trialLimit;
        this.accountType = 1;
        this.purchased = true;
      } else if (packageId === 4) {
        this.credits = 3995;
        this.trialLimit = this.trialLimit;
        this.accountType = 1;
        this.purchased = true;
      }
      else {
        this.credits = packageList[0]['totalCost'];
        this.trialLimit = this.trialLimit;
        this.accountType = 1;
        this.purchased = true;
      }
    // },
  },
    async onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      // this.currentPage = 1
    },
    async getUsers() {
      this.users = await API.get('Accounts?filter={"order": "created DESC"}');
      this.totalRows = this.users.length;
    },
    async getHistory(userId) {
      this.$router.push(`/admin/userHistory?id=${userId}`);
    },
    async getProductKey(userId) {
      this.$router.push(`/admin/productKey?id=${userId}`);
    },
    async getLoginHistory(userId) {
      this.$router.push(`/admin/loginHistory?id=${userId}`);
    },
    async getDetail(userId) {
      const accountDetail = await API.get(`Accounts/${userId}`);
      this.trialLimit = accountDetail.trialLimit;
      this.devices = accountDetail.totalDevices;
      this.amount = accountDetail.packageId;
      this.credits = accountDetail.credits;
      this.extracredits = accountDetail.extracredits;
      this.purchased = accountDetail.purchased;
      this.accountType = accountDetail.accountType;
      try {
        this.datePickerVal = accountDetail.expiryDate.split('T')[0];
      } catch (e) { }
      // console.log(accountDetail)
      this.userId = userId;
      this.userSettingsModal = true;
    },
    async getPackageList() {
      try {
        const packageList = await API.get('PackageLists');
        //this.options = packageList;
		
		this.options  = await packageList.slice().sort((a, b) => {
		  const strA = String(a.planId || '').trim();
		  const strB = String(b.planId || '').trim();

		  const numA = parseInt(strA, 10);
		  const numB = parseInt(strB, 10);

		  const isNumA = !isNaN(numA);
		  const isNumB = !isNaN(numB);
		  if (isNumA && isNumB) {
			return numA - numB;
		  } else if (isNumA && !isNumB) {
			return -1;
		  } else if (!isNumA && isNumB) {
			return 1;
		  } else {
			return strA.localeCompare(strB, undefined, { numeric: true, sensitivity: 'base' });
		  }
		});		
		
		/*this.options = localList.sort((a, b) => {
		  const aUid = a.userId || '';
		  const bUid = b.userId || '';

		  // Push target UUID to top
		  if (aUid === TARGET_UUID && bUid !== TARGET_UUID) return -1;
		  if (bUid === TARGET_UUID && aUid !== TARGET_UUID) return 1;


		  // Otherwise order by numeric id
		  const aId = a.id != null ? Number(a.id) : Infinity;
		  const bId = b.id != null ? Number(b.id) : Infinity;

		  return aId - bId;
		});*/
      } catch (error) {
        console.error(error);
      }
    },
    async updateProfile(scope) {
      try {
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          const clientId = this.userId;
          await API.patch(`Accounts/${clientId}`, {
            packageId: this.amount,
            credits: this.credits,
            extracredits: this.extracredits,
            // trialLimit: this.trialLimit,
            accountType: this.accountType,
            purchased: this.purchased,
            totalDevices: this.devices,
            expiryDate: this.datePickerVal
          });
          this.userId = null;
          this.userSettingsModal = false;
          this.$notify({
            group: 'sitewide',
            title: 'Success!',
            type: 'success',
            text: 'Updated Sucessfully',
          });
        }
      } catch (error) {
        this.userId = null;
        this.userSettingsModal = false;
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error while update',
        });
      }
    },
    async statusUpdate(userId, currentStatus) {
      try {
        await API.patch(`Accounts/${userId}`, {
          payAsGo: currentStatus,
        });
      } catch (error) {
        await this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Unable to update status',
        });
        this.getUsers();
      }
    },
    async emailStatusUpdate(userId, currentStatus) {
      try {
        await API.patch(`Accounts/${userId}`, {
          emailVerified: currentStatus,
        });
      } catch (error) {
        await this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Unable to update status',
        });
      }
      this.getUsers();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}

.icon-width {
  width: 20px !important;
  height: 20px !important;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #6610f2 !important;
  border-color: #6610f2 !important;
}

.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}

.clearBtn {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
  margin-left: 10px;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked+.slider {
  background-color: #d6700a;
}

input:focus+.slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}

.switch input {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/users.vue